import { apiClient, type ApiResponse } from '@/lib/apiClient';
import type { QueryOptions } from '@/lib/reactQuery';
import { useQuery } from '@tanstack/react-query';

type GetInviteTokenValidityResponse = ApiResponse<{ invitationValid: boolean }>;

export const getInviteTokenValidity = async ({ invitationToken }: { invitationToken: string }) => {
  const response = await apiClient.get<GetInviteTokenValidityResponse>(`/v1/auth/invitation-validity/${invitationToken}`);
  return response.data;
};

interface UseGetInviteTokenValidityOptions {
  invitationToken: string;
  options?: QueryOptions<GetInviteTokenValidityResponse>;
}

export const useGetInviteTokenValidity = ({ invitationToken, options }: UseGetInviteTokenValidityOptions) => {
  return useQuery({
    queryKey: ['getInviteTokenValidity', invitationToken],
    queryFn: () => getInviteTokenValidity({ invitationToken }),
    ...options,
  });
};
